import api from '@/api/index.js'

const fare_group = {
  state: {
    loading: false,
    updating: false,
    data: null,
    error: null
  },

  mutations: {
    SET_FARE_GROUP_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_FARE_GROUP_UPDATING: (state, updating) => {
      state.updating = updating;
    },
    SET_FARE_GROUP: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_FARE_GROUP_UPDATED: (state, updated) => {
      state.data.description = updated.description;
      state.data.modified_by = updated.modified_by;
      state.data.updated_at = updated.updated_at;
      state.data.details = updated.details;
      state.updating = false;
    },
    SET_FARE_GROUP_ERROR: (state, error) => {
      state.error = error;
      state.loading = false;
    },
  },

  actions: {
    LoadFareGroup({commit}, fareGroupID) {
      commit('SET_ERROR', null);
      commit('SET_FARE_GROUP_ERROR', null)
      commit('SET_FARE_GROUP_LOADING', true)
      return api.get(`fare-groups/${fareGroupID}`)
        .then((response) => {
          commit('SET_FARE_GROUP', response)
        })
        .catch((error) => {
          commit('SET_FARE_GROUP', null);
          commit('SET_FARE_GROUP_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
    UpdateFareGroup({commit}, payload) {
      commit('SET_FARE_GROUP_UPDATING', true);
      commit('SET_FARE_GROUP_ERROR', null)
      return api.put(`fare-groups/${payload.id}`, payload)
        .then((response) => {
          commit('SET_FARE_GROUP_UPDATED', response.body)
        })
        .catch((error) => {
          commit('SET_FARE_GROUP_ERROR', error);
          commit('SET_FARE_GROUP_UPDATING', false)
        })
    },
    DeleteFareGroup({commit}, payload) {
      commit('SET_FARE_GROUP_UPDATING', true);
      commit('SET_ERROR', null);
      commit('SET_FARE_GROUP_ERROR', null);
      return api.delete(`fare-groups/${payload.id}`)
        .then((response) => {
          commit('SET_FARE_GROUP_UPDATING', false)
        })
        .catch((error) => {
          commit('SET_FARE_GROUP_ERROR', error);
          commit('SET_INTERACTION_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_FARE_GROUP_UPDATING', false);
        })
    },
  },
}

export default fare_group
